import ReactGA from "react-ga4";
import SHA256 from 'crypto-js/sha256';

export const customLogs = (...args) => {
    const Confdata = window['runConfig'];
    // console.log("Confdata", Confdata)
    if (Confdata.showConsole) {
        console.log(...args); // Logs messages to the console only if                                        
        // showConsole is true
    }
}

export const errorMessages = {
    400: 'Errorcode_400', // Bad Request
    401: 'Errorcode_401', // Unauthorized
    403: 'Errorcode_403', // Forbidden
    404: 'Errorcode_404', // Not Found
    422: 'Errorcode_422', // Unprocessable Entity
    500: 'Errorcode_500', // Internal Server Error
    502: 'Errorcode_502', // Bad Gateway
    503: 'Errorcode_503', // Service Unavailable
    504: 'Errorcode_504', // Gateway Timeout
    'ECONNABORTED': 'Errorcode_ECONNABORTED', // Request Timeout
    'NO_RESPONSE': 'Errorcode_NO_RESPONSE', // No response from server
    unexpected: 'Errorcode_unexpected', // Unexpected response format
    default: 'Errorcode_default', // Default fallback message
    1111: 'Errorcode_1111' // Custom Error
};

export const handleApiResponseError = (status, statusDesc) => {
    // If status and statusDesc are undefined, return an unexpected error message
    if (status === undefined && statusDesc === undefined) {
        return errorMessages.unexpected;
    }
       // Check if the status code matches a predefined error message
       const errorMessage = errorMessages[status] || statusDesc || errorMessages.default;
       return errorMessage; // Return either the predefined message, API's statusDesc, or the default message
   };


export const handleApiCatchError = (error) => {
    let errorMessage = errorMessages.default; // Default error message

    // Handle timeout or aborted request errors
    if (error.code === 'ECONNABORTED') {
        errorMessage = errorMessages['ECONNABORTED'];
    } else if (error.response) {
        // If the server responded with an error
        if (error.response.data) {
            // Use the status code or statusDesc from the response, if available
            const status = error.response.data.status;
            const description = error.response.data.statusdesc || error.response.data.statusdescription;
            errorMessage = handleApiResponseError(status, description);
        } else {
            // Fallback to status code, message, or status text
            errorMessage = errorMessages[error.response.status] ||
                error.response.data?.message ||
                error.response.statusText ||
                errorMessages.default;
        }
    } else if (error.request) {
        // If no response was received from the server
        errorMessage = errorMessages['NO_RESPONSE'];
    } else if (error.message) {
        // Use the error's message as the fallback
        errorMessage = error.message;
    }
    return errorMessage; // Return the determined error message
};


// export const logGAEvent = (category, action, label, userId = null) => {
//     try {
//         const eventParams = {
//             "category":category,
//             "action":action,
//             "label":label,
//             "timestamp": new Date().toISOString()
//         };

//         if (userId) {
//             eventParams.userId = userId;
//             ReactGA.set({ userId }); // Set user ID for tracking
//         }

//         ReactGA.event(eventParams);
//         customLogs("GA Event Logged:", eventParams); // Debugging log
//     } catch (error) {
//         console.error("GA Event Logging Failed:", error);
//     }
// };

export const logGAEvent = (category, action, label, userId = null) => {
    try {
        const eventParams = {
            category,
            action,
            label,
            timestamp: new Date().toISOString()
        };

        if (userId) {
            const hashedEmail = SHA256(userId).toString();
            ReactGA.set({ user_id: hashedEmail }); // ✅ Correct key: user_id
        }

        ReactGA.event("custom_event", eventParams); // ✅ Must specify event name in GA4

        customLogs("GA Event Logged:", eventParams); // Debugging log
    } catch (error) {
        console.error("GA Event Logging Failed:", error);
    }
};